import { all, call, delay, put, takeLatest } from 'redux-saga/effects';

import * as notificationActions from '@/shared/modules/notification/actions';
import config from '@/config';
import { getAudioPath } from '@/shared/config/routes';
import { processRequest, RequestMethod } from '@/shared/services/api';
import * as playButtonActions from '../store/actions';
import { playButtonActionTypes } from '../store/constants';

import type { Action } from '@/shared/app';
import type { SongData } from '../types';

interface GetSongPayload {
	id: string | number;
	word: string;
	lang: string;
}

interface ApiError {
	response?: {
		data?: {
			error?: string;
		};
	};
}

export default function* playButtonSaga() {
	yield all([takeLatest(playButtonActionTypes.GET_SONG_REQUEST, handleGetSong)]);
}

export function* handleGetSong(action: Action<GetSongPayload>) {
	try {
		const { id, word, lang } = action.payload || {};

		if (id == null || !word || !lang) {
			yield put(playButtonActions.removeSong());
			return;
		}

		if (!config.enable_speak_audio) {
			yield put(playButtonActions.removeSong());
			return;
		}

		const audioPath = getAudioPath(lang, word);
		let { data }: { data: SongData } = yield call(processRequest, audioPath, RequestMethod.GET);
		let hasUrl = data?.url;
		while (!hasUrl) {
			const { data: data_ }: { data: SongData } = yield call(processRequest, audioPath, RequestMethod.GET);
			yield delay(1000);
			hasUrl = data_.url;
			data = data_;
		}
		yield put(playButtonActions.getSongSuccess(id, data));
	} catch (e) {
		const error = e as ApiError;
		yield put(notificationActions.createNotification(error.response?.data?.error, null, true, 5000));
		yield put(playButtonActions.removeSong());
	}
}
